export default function online(state=true, action) {
  switch (action.type) {
    case 'SET_NETWORK_STATUS': 
      return action.network_status; 
  }
  return state;
}
